module.exports = __webpack_public_path__ + "img/linux-104-1-1.34e75213.png";